export default __webpack_public_path__ + "static/media/property_261.5ddae77b.png";